import React from 'react';
import { AEMContent, Grid, PageWrapper } from '@mlc/web-ui-toolkit';
import { useDispatch } from 'react-redux';
import GridRow from '../../common/ResponsiveGrid/GridRow';
import { clearSearchFiltersAction } from '../../../store/actions/search.filter.actions';
import ClientActionList from './ClientActionList/ClientActionList';
import CallToAction from './CallToAction/CallToAction';
import ExternalLinksList, { Link } from './ExternalLinksList/ExternalLinksList';
import { Tile } from './styled';

interface Props {
	actionItems: ActionItem[];
	externalLinksList: Link[];
}

interface ActionItem {
	name: string;
	link: string;
	text: string;
	icon: string;
	launch: string;
}

const Dashboard: React.FunctionComponent<Props> = props => {
	// Remove any saved filters
	useDispatch()(clearSearchFiltersAction());

	return (
		<PageWrapper>
			<Grid>
				<GridRow>
					{props.actionItems.map(item => (
						<CallToAction key={item.name} {...item} />
					))}
				</GridRow>
				<GridRow>
					<ClientActionList />
					<Tile>
						<AEMContent path="/secure/_content/Adviser/home/home-page-message-tile" />
					</Tile>
					<ExternalLinksList links={props.externalLinksList} />
				</GridRow>
			</Grid>
		</PageWrapper>
	);
};

export default Dashboard;
